<div class="container exitpage">
	<header role="banner" class="site-header" id="testata">
		<h1 class="sr-only">Sessione Scaduta - Teleforum</h1>
		<a [routerLink]="urlWelcomeBoard"  appTooltip="Torna alla home" placement="bottom" [appTooltipEnabled]="true">
			<img src="img/logo.png" alt="Teleforum logo">
			<span class="sr-only">Torna alla home di Teleforum</span>
		</a>
	</header>
	<hr class="hidden">
	<div id="content-container">
		<main id="content">
		<h2 class="first_title">Errore</h2>
		<div class="content-page-wrapper">
			<div class="standardpanel">
				<div class="container_dati_generali">
					<div class="row">
						<div class="col-sm-12">
							<p class="allinea_centro">
								<label>{{ message._body ?  message._body : message }}</label>
								<label>{{ (messageViewManager && messageViewManager.text() && messageViewManager.text().indexOf('Login failed') >= 0) ?  'Login fallito' : '' }}</label>
								<button class="btn btn-primary" type="submit" (click)="redirectHome()">Home page</button>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		</main>
	</div>
</div>